import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { store } from "./store";
import { Theme } from "@twilio-paste/core/theme";
import { Box } from "@twilio-paste/core";
import App from "./components/App";
import styles from "../src/styles";
import { MsalProvider } from "@azure/msal-react";
import { pca } from "./auth/msal.client";
import { BrowserRouter } from "react-router-dom";
import { SignalRProvider } from "./signalr/SignalRProvider";

if (process.env.NODE_ENV === "development") {
  require("./signalr/debug");
}

(async function init() {
  if (
    process.env.NODE_ENV === "development" &&
    (process.env.REACT_APP_USE_FAKE_MSAL ?? "false") === "true"
  ) {
    const { worker } = await import("./mocks/browser");

    await worker.start({ onUnhandledRequest: "bypass" });
  }

  await pca.initialize();

  ReactDOM.render(
    <BrowserRouter>
      <Box style={styles.app}>
        <React.StrictMode>
          <Provider store={store}>
            <SignalRProvider>
              <Theme.Provider theme="twilio">
                <Box style={styles.app}>
                  <MsalProvider instance={pca}>
                    <App />
                  </MsalProvider>
                </Box>
              </Theme.Provider>
            </SignalRProvider>
          </Provider>
        </React.StrictMode>
      </Box>
    </BrowserRouter>,
    document.getElementById("root")
  );
})();
